import { useDateDisplayText } from '@/composables/UseDateDisplayText'

/**
 * ユーザーリスト表示項目(登録日時)の利用
 * @param {MaybeRef.<string>} at 登録日時
 * @param {MaybeRef.<string>} baseDate 基準日時
 */
export function useUserStatusAdditionalItemRegistration({ at, baseDate }) {
  const { formattedDate, diffText, text } = useDateDisplayText({
    date: at,
    baseDate,
  })
  return { formattedDate, diffText, text }
}
